import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { EActionTypes } from '../../constants/actionTypes/currentRealtor';

export const setCurrentRealtor = actionGenerator<EActionTypes.Set, ISpecialistCatalogListingSchema>(EActionTypes.Set);
export const resetCurrentRealtor = actionGenerator<EActionTypes.Reset>(EActionTypes.Reset);

export type TSetCurrentRealtor = ReturnType<typeof setCurrentRealtor>;
export type TResetCurrentRealtor = ReturnType<typeof resetCurrentRealtor>;

export type TCurrentRealtorActions = TSetCurrentRealtor | TResetCurrentRealtor;
